import { LinkProviderType } from 'owa-fileprovider-link';
import { lazyExtractFileUrlFromOfficeSharePointLink } from 'owa-sharepoint-link-detector';
import { tryRemoveSafeLinkWrap } from '../tryRemoveSafeLinkWrap';

/*
For SafeLink, the original file url is wrapped inside the href "https://nam06.safelinks.protection.outlook.com/?url=https%3A%2F%2F...""
We need to remove safelink wrap to get the file url in order to call file provider to retrieve file info such as file name and permission.
We need the second level unwrapping for offline links
https://www.office.com/launch/excel/content?auth=2&drive=b!Pk3L9gD7MUy17EcRL6KaPWVjBGonkuJIu88mgA7-VOwAz4c4l9d3T5WnHXKwXliy&item=013JTXF6NYOAEEDQPZURHL3QHZSAF5V7DU&file=https:%2F%2Fmicrosoft-my.sharepoint-df.com%2Fpersonal..
We can't use this url to call getsharinginformation, and also need to retrieve the file url from file parameter.
*/
export async function tryGetUnwrappedUrl(
    anchorElement: HTMLAnchorElement,
    providerType: LinkProviderType
) {
    let url: string = await tryRemoveSafeLinkWrap(anchorElement, false /* skipUnsupportedLinks */);
    if (providerType === LinkProviderType.OfficeOneDrivePro) {
        const extractFileUrlFromOfficeSharePointLink = await lazyExtractFileUrlFromOfficeSharePointLink.import();
        url = extractFileUrlFromOfficeSharePointLink(url);
        if (!url) {
            throw new Error('Can not get ODB URL from Office link.');
        }
    }
    return url;
}
